import { type Track, locateTrackPosition } from '../track/TrackLoader';
import { type InputState, type RacerState } from './Physics';

export interface RaceStartPose {
  x: number;
  z: number;
  heading: number;
}

export function gridPoseAtLateral(track: Track, startPose: RaceStartPose, lateral: number): RaceStartPose {
  const pos = locateTrackPosition(track, startPose.x, startPose.z);
  return {
    x: pos.closestX + pos.nx * lateral,
    z: pos.closestZ + pos.nz * lateral,
    heading: startPose.heading,
  };
}

export function rolledBackProgress(totalLength: number, rollbackMeters: number): number {
  return wrapProgress(totalLength - Math.max(0, rollbackMeters), totalLength);
}

export function countdownLabel(remainingSeconds: number): string {
  if (remainingSeconds <= 0) return '';
  if (remainingSeconds <= 0.45) return 'GO';
  return String(Math.max(1, Math.ceil(remainingSeconds - 0.45)));
}

export function pinRacerStateForStartHold(
  state: RacerState,
  pose: RaceStartPose,
  groundY: number,
): void {
  state.position.set(pose.x, groundY, pose.z);
  state.velocity.set(0, 0, 0);
  state.heading = pose.heading;
  state.yawVelocity = 0;
  state.verticalVelocity = 0;
  state.airborne = false;
}

export function startHoldThrottleSignal(input: Pick<InputState, 'throttle' | 'leftThrust' | 'rightThrust'>): number {
  const throttle = clamp01(input.throttle);
  const left = clamp01(input.leftThrust ?? throttle);
  const right = clamp01(input.rightThrust ?? throttle);
  return Math.max(throttle, (left + right) * 0.5);
}

function clamp01(value: number): number {
  return Math.max(0, Math.min(1, value));
}

function wrapProgress(progress: number, totalLength: number): number {
  const total = Math.max(1e-6, totalLength);
  return ((progress % total) + total) % total;
}
